<template>
  <SettingsPageLayout>
    <DetailForm
      v-if="loaded"
      title="Stripe"
      description="The Stripe integration allows us to connect all of your billing information directly in Humaniz from Stripe where it is stored."
      action="Save"
      hidecancel="true"
      @handle-action="updateTeam"
    >
      <TextInput
        label="Stripe Customer Id"
        placeholder="cus_N6NLGguLBSmSVj"
        :model-value="team.stripeCustomerId"
        @update:model-value="value => (team.stripeCustomerId = value)"
      />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      team: {
        id: '',
        stripeCustomerId: '',
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch('/api/team')
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.team.id = data.id;
          self.team.stripeCustomerId = data.record.stripe_customer_id;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/api/team', {
        method: 'PUT',
        body: JSON.stringify({
          stripe_customer_id: self.team.stripeCustomerId,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('Stripe integration updated', {
              action: { label: 'Dismiss' },
              description:
                'Your Stripe integration was successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('Stripe integration update error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
